import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { connect, useSelector, useDispatch } from "react-redux";
import Layout from "../../components/layout/Layout";
import { ManageVehcleList } from "../../redux/action/vehicle";
import { Link } from "react-router-dom";
import search from "../../utils/search";
import Pagination from "../../components/Pagination";
import { CSVLink } from "react-csv";
import ViewVehicle from "./ViewVehicle";
import { deleteVehicle, deleteMultiVehicle } from "../../redux/action/vehicle";
import { APIURL } from "../../redux/action/config";
import loader from "../../components/loader/loader";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import dateFormat from "dateformat";
import NoImage from "../../assets/images/noimages.jpg";

const VehicleList = ({ pageLoading, rentalsData, not_found }) => {
  const [id, setId] = useState();
  const vehicleList = useSelector((state) => state?.vehicles?.list);
  const dispatch = useDispatch();

  const [productDataList, setProductDataList] = useState([]);
  const onChangePage = (pageOfItems) => {
    setProductDataList(pageOfItems);
  };

  const [viewDetails, setViewDetails] = useState();

  const handleGetId = (e, id) => {
    e?.preventDefault();
    if (!id) return;
    if (id !== undefined) {
      const token = localStorage.getItem("token");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${APIURL}/api/v1/vehicle/${id}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          setViewDetails(result);
        })
        .catch((error) => console.log("error", error));
    }
  };

  useEffect(() => {
    dispatch(ManageVehcleList());
  }, [dispatch]);

  const vehicles = vehicleList?.data ? vehicleList?.data?.vehicle : "";

  const VehicleDel = (id) => {
    dispatch(deleteVehicle(id));
    setTimeout(() => {
      dispatch(ManageVehcleList());
    }, 1000);
  };

  const headers = [
    { label: "_id", key: "id" },
    { label: "Image", key: "image" },
    { label: "Vehicle Name", key: "name" },
    { label: "Vehicle Modal", key: "vehicle_model" },
    { label: "Price($)", key: "price" },
    { label: "perWeekPrice($)", key: "perWeekPrice" },
    { label: "Registration No", key: "registration_no" },
    { label: "Color", key: "color" },
    { label: "Year", key: "year" },
    { label: "Booking Status", key: "bookingStatus" },
    { label: "Status", key: "status" },
    { label: "Created_At", key: "created" },
    { label: "Updated_At", key: "updated" },
  ];
  // const data = productDataList
  //   ? productDataList?.map((item) => {
  //       return {
  //         id: item?._id ? item?._id : "N/A",
  //         image: item?.image ? item?.image : "N/A",
  //         name: item.name ? item.name : "N/A",
  //         vehicle_model: item?.vehicle_model ? item?.vehicle_model : "N/A",
  //         price: item?.price ? item?.price : "N/A",
  //         perWeekPrice: item?.perWeekPrice ? item?.perWeekPrice : "N/A",
  //         registration_no: item?.registration_no
  //           ? item?.registration_no
  //           : "N/A",
  //         color: item?.color ? item?.color : "N/A",
  //         year: item?.year ? item?.year : "N/A",
  //         bookingStatus: item?.isBooked ? item?.isBooked : "N/A",
  //         status: item?.status ? item?.status : "N/A",
  //         created: item?.createdAt ? item?.createdAt : "N/A",
  //         updated: item?.updatedAt ? item?.updatedAt : "N/A",
  //       };
  //     })
  //   : "";

  const getBadge = (status) => {
    switch (status) {
      case "active":
        return "success";
      case "inactive":
        return "secondary";
      default:
        return "primary";
    }
  };

  const getBookingBadge = (isBooked) => {
    switch (isBooked) {
      case "booked":
        return "success";
      case "book":
        return "secondary";
      default:
        return "primary";
    }
  };

  // *********** All Select Delete ***********
  const [btnStatus, setBtnStatus] = useState(false);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [isCheck, setIsCheck] = useState([]);
  const [list, setList] = useState([]);

  useEffect(() => {
    setList(productDataList);
  }, [productDataList]);

  const handleSelectAll = (e) => {
    setIsCheckAll(!isCheckAll);
    setIsCheck(list.map((li) => li.id));
    if (isCheckAll) {
      setIsCheck([]);
    }
  };

  const handleClick = (e) => {
    const { id, checked } = e.target;
    setIsCheck([...isCheck, id]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== id));
    }
  };
  const handleAllDelete = () => {
    dispatch(deleteMultiVehicle(isCheck));
    setTimeout(() => {
      dispatch(ManageVehcleList());
      setIsCheckAll(false);
      setIsCheck([]);
    }, 1000);
  };

  // Download csv files - export the selected rows, or the whole visible list if nothing is checked
  const seledCsvList =
    isCheck?.length > 0
      ? productDataList?.filter((item) => isCheck?.includes(item?.id))
      : productDataList;
  const data = seledCsvList
    ? seledCsvList?.map((item) => {
      return {
        id: item?._id ? item?._id : "N/A",
        image: item?.image ? item?.image : "N/A",
        name: item.name ? item.name : "N/A",
        vehicle_model: item?.vehicle_model ? item?.vehicle_model : "N/A",
        price: item?.price ? item?.price : "N/A",
        perWeekPrice: item?.perWeekPrice ? item?.perWeekPrice : "N/A",
        registration_no: item?.registration_no
          ? item?.registration_no
          : "N/A",
        color: item?.color ? item?.color : "N/A",
        year: item?.year ? item?.year : "N/A",
        bookingStatus: item?.isBooked ? item?.isBooked : "N/A",
        status: item?.status ? item?.status : "N/A",
        created: item?.createdAt ? item?.createdAt : "N/A",
        updated: item?.updatedAt ? item?.updatedAt : "N/A",
      };
    })
    : "";

  const downloadPDF = () => {
    const capture = document.querySelector(".table");
    html2canvas(capture).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      console.log("Image Data:", imgData); // Debugging: Log the image data
      const doc = new jsPDF("p", "mm", "a4");
      const imgWidth = 200; // Adjust this based on your needs
      const imgHeight = (imgWidth * canvas.height) / canvas.width; // Maintain aspect ratio
      doc.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      doc.save("roadside-response.pdf");
    });
  };

  // date filter start
  const [filterDate, setFilterData] = useState({
    startDate: "",
    endDate: "",
  });

  const [listData, setListData] = useState([]);

  const startDate = filterDate?.startDate;
  const endDate = filterDate?.endDate;

  const handleOnchangeFilter = (e) => {
    const { name, value } = e.target;
    setFilterData({
      ...filterDate,
      [name]: value,
    });
  };

  const handleResetFilter = () => {
    setFilterData({ startDate: "", endDate: "" });
  };

  useEffect(() => {
    if (!vehicles) return;
    if (!startDate && !endDate) {
      setListData(vehicles);
      return;
    }
    const filteredDataList = vehicles.filter((obj) => {
      const objDate = dateFormat(obj.createdAt, "yyyy-mm-dd");
      return (!startDate || objDate >= startDate) && (!endDate || objDate <= endDate);
    });
    setListData(filteredDataList);
  }, [vehicles, startDate, endDate]);
  // date filter End

  return (
    <React.Fragment>
      <ToastContainer autoClose={1000} />
      <Layout title="Manage All Rentals" page="vehicles">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            <div className="row pt-4 pb-4">
              <div className="col-sm-6 d-flex align-items-center justify-conten-start">
                <div
                  className="dataTables_length"
                  id="kt_datatable_example_5_length"
                >
                  <div className="filter-table-data ml-5 d-flex align-items-center">
                    {isCheck && isCheck?.length > 0 ? (
                      <button
                        onClick={() => {
                          handleAllDelete();
                        }}
                        className="delete-selected me-4"
                      >
                        Delete Selected
                      </button>
                    ) : (
                      ""
                    )}
                    <div className="">
                      <input
                        className="form-control"
                        name="startDate"
                        type="date"
                        value={startDate}
                        onChange={(e) => {
                          handleOnchangeFilter(e);
                        }}
                      />
                    </div>
                    <span className="mx-4 fw-bolder">To</span>
                    <div>
                      <input
                        className="form-control"
                        name="endDate"
                        type="date"
                        min={startDate || ""}
                        value={endDate}
                        onChange={(e) => {
                          handleOnchangeFilter(e);
                        }}
                      />
                    </div>
                    {(startDate || endDate) ? (
                      <button
                        type="button"
                        className="btn btn-light-danger ms-2"
                        onClick={handleResetFilter}
                      >
                        Reset
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 d-flex align-items-center justify-content-end">
                <div
                  id="kt_datatable_example_5_filter"
                  className="dataTables_filter"
                >
                  <label>
                    Search:
                    <input
                      type="search"
                      onChange={() => {
                        search();
                      }}
                      id="myInput"
                      className="form-control form-control-sm form-control-solid"
                      placeholder=""
                      aria-controls="kt_datatable_example_5"
                    />
                  </label>
                </div>
                <div className="ms-3">
                  <a
                    className="btn pgf btn-secondary dropdown-toggle"
                    href="#"
                    // role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    // className="csvlink"
                    style={{ background: "none" }}
                  >
                    Download File
                  </a>

                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item">
                        <CSVLink
                          style={{ color: "#000" }}
                          data={data}
                          headers={headers}
                        >
                          Download as CSV
                        </CSVLink>
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" onClick={downloadPDF}>
                        Download as PDF
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="table-responsive table-wrapper">
              <table
                id="kt_datatable_example_5"
                className="table table-striped table-row-bordered gy-5 gs-7 border rounded dataTable no-footer status"
                aria-describedby="kt_datatable_example_5_info"
              >
                <thead>
                  <tr className="fw-bolder fs-6 text-gray-800 px-7 arrow-none">
                    <th style={{ padding: "16px 0px 16px 24px" }}>
                      <input
                        type="checkbox"
                        name="selectAll"
                        id="selectAll"
                        onClick={() => {
                          handleSelectAll();
                          setBtnStatus(true);
                        }}
                        checked={isCheckAll}
                        className="form-check-input custum-check"
                      />
                    </th>
                    <th>Vehicle Image</th>
                    <th>Vehicle Name</th>
                    <th>Vehicle Model</th>
                    <th>Price($)</th>
                    <th className="text-center">Per Week Price($)</th>
                    <th className="text-center">Booking Status</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {!pageLoading && vehicles?.length ? (
                    productDataList &&
                    productDataList?.map((item, index) => {
                      return (
                        <tr key={index} className="pro-list-info">
                          <td style={{ width: "20px" }} className="check-list">
                            <input
                              type="checkbox"
                              name={item?.firstName}
                              id={item?.id}
                              onClick={(e) => handleClick(e)}
                              checked={isCheck?.includes(item?.id)}
                              className="form-check-input custum-check"
                            />
                          </td>
                          <td>
                            <img
                              className="service-img"
                              src={
                                item.image
                                  ? APIURL + "/" + item.image
                                  : NoImage
                              }
                              alt="vehicle image"
                            />
                          </td>
                          <td>{item.name ? item.name : "N/A"}</td>
                          <td>
                            {item?.vehicle_model ? item?.vehicle_model : "N/A"}
                          </td>
                          <td>${item.price ? item.price : "N/A"}</td>
                          <td className="text-center">
                            ${item.perWeekPrice ? item.perWeekPrice : "N/A"}
                          </td>
                          <td className="text-center">
                            <span
                              className={`btn ${getBookingBadge(
                                item.isBooked
                              )}`}
                            >
                              {item?.isBooked == "book"
                                ? "Available for booking"
                                : item?.isBooked == "booked"
                                  ? "Booked"
                                  : ""}
                            </span>
                          </td>
                          <td>
                            <span className={`btn ${getBadge(item.status)}`}>
                              {item.status == "active"
                                ? "Active"
                                : item.status == "inactive"
                                  ? "Inactive"
                                  : ""}
                            </span>
                          </td>
                          <td>
                            <ViewVehicle
                              modalId={"vehicleModal"}
                              viewDetails={viewDetails ? viewDetails : ""}
                            />
                            <a
                              type="button"
                              onClick={(e) => handleGetId(e, item?.id)}
                              className="btn btn-primary"
                              data-bs-toggle="modal"
                              data-bs-target="#vehicleModal"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-eye-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                              </svg>
                            </a>
                            {/* <Link
                              to="#"
                              onClick={() => setId(item.id)}
                              className="btn btn-bg-primary action-hover"
                              data-bs-toggle="modal"
                              data-bs-target="#vehicleModal"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-eye-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z" />
                              </svg>
                            </Link> */}
                            <Link
                              to={`/edit-vehicle/${item.id}`}
                              onClick={() => setId(item.id)}
                              className="btn btn-info action-hover"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-pencil-square"
                                viewBox="0 0 16 16"
                              >
                                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"></path>
                                <path
                                  fillRule="evenodd"
                                  d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                ></path>
                              </svg>
                            </Link>
                            <Link
                              to="/all-rentals"
                              onClick={() => VehicleDel(item.id)}
                              className="btn btn-bg-dark action-hover"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-trash-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                              </svg>
                            </Link>
                          </td>
                        </tr>
                      );
                    })
                  ) : productDataList?.length === 0 ||
                    listData?.length === 0 ? (
                    <div className="spinner-outer p-5">
                      <p>Data not found</p>
                    </div>
                  ) : (
                    <div className="spinner-outer p-5">{loader()}</div>
                  )}
                </tbody>
              </table>
            </div>
            {/* <Pagination
              pageSize={10}
              items={vehicles}
              onChangePage={onChangePage}
            /> */}

            {listData && listData ? (
              <Pagination
                pageSize={10}
                items={listData}
                onChangePage={onChangePage}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  pageLoading: state?.vehicles?.loading,
  rentalsData: state?.vehicles?.list,
  not_found: state?.vehicles?.not_found,
});

export default connect(mapStateToProps, { ManageVehcleList })(VehicleList);
